import React, { useEffect, useState, useRef } from "react";

import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Checkbox from "@mui/material/Checkbox";
import Avatar from "@mui/material/Avatar";
import constants from "../../common/constants";

const DepartmentSelectionModal = ({
  departmentSelectionModalOpen,
  closeModal,
  handleSubmitDepartment,
  currentDepartment,
  handleSelectFiles,
  files,
  disabledUpload,
}) => {
  const [checked, setChecked] = React.useState([]);
  const departmentsArray = [
    constants.CLAIMS,
    constants.GRIEVANCE,
    constants.OPERATIONS,
    constants.UNDERWRITING,
  ];

  const findAndPop = (array, elementToFind) => {
    const index = array.findIndex((element) => element === elementToFind);

    if (index !== -1) {
      const poppedElement = array.splice(index, 1)[0];
      return poppedElement;
    }

    return undefined; // Element not found
  };
  findAndPop(departmentsArray, currentDepartment);
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  return (
    <>
      <Dialog
        open={departmentSelectionModalOpen}
        onClose={closeModal}
        sx={{ "& .MuiDialog-paper": { minWidth: "350px" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignpolicyDetailss: "center",
          }}
        >
          <>Select Departments</>
          <CloseIcon
            onClick={() => closeModal()}
            color="primary"
            sx={{
              height: "100%",
              cursor: "pointer",
            }}
          />
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          <Grid
            container
            size={{ xs: 12, md: 6 }}
            justifyContent="center"
            alignItems="center"
            spacing={2} // Add spacing between items
            sx={{
              m: 1,
            }}
          >
            <List
              dense
              sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            >
              {departmentsArray.map((value) => {
                const labelId = `checkbox-list-secondary-label-${value}`;
                return (
                  <ListItem
                    key={value}
                    onClick={handleToggle(value)}
                    secondaryAction={
                      <Checkbox
                        edge="end"
                        // onChange={handleToggle(value)}
                        checked={checked.includes(value)}
                      />
                    }
                    // disablePadding
                  >
                    <ListItemButton>
                      <ListItemText
                        id={labelId}
                        primary={value.replace("_", " ")}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ display: "flex", justifyContent: "end" }}>
          <Button
            // fullWidth
            onClick={() => {
              handleSubmitDepartment(checked);
              // console.log("oooooooooooooooooooo", checked);
              // setDepartmentSelectionModalOpen(true);
            }}
            sx={{
              mb: 2,
              mx: 2,
              borderRadius: "10px",
              background: "rgb(245, 132, 31)",
            }}
            variant="contained"
            disabled={checked?.length === 0}
          >
            Send to Departments
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DepartmentSelectionModal;
